import { render, staticRenderFns } from "./WillExpire.vue?vue&type=template&id=00f6f9db&scoped=true"
import script from "./WillExpire.vue?vue&type=script&lang=js"
export * from "./WillExpire.vue?vue&type=script&lang=js"
import style0 from "./WillExpire.vue?vue&type=style&index=0&id=00f6f9db&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f6f9db",
  null
  
)

export default component.exports